/**
 * Block a task — one dialog. Waiting on (client / us / third party) and the
 * reason live inside `tasks_block`; no one-click preset buttons beside Status.
 *
 * The words are `DIALOG_MOVES`', since correction round 1: the same move is offered
 * here, in the row's More menu and in the list's status cell, and three spellings of
 * "Say what it is waiting for" is how three surfaces come to disagree.
 */

import type { TaskView } from '@fareast/shared'

import { ActionDialog } from '../../../components/studio/ActionDialog.js'
import { DIALOG_MOVES, moveWindowOf } from '../../../components/studio/taskWords.js'

export type BlockControlProps = {
  readonly task: TaskView
  /** True while a move beside it is on its way (`ActionDialog` `disabled`). */
  readonly disabled?: boolean | undefined
}

export function BlockControl({ task, disabled }: BlockControlProps) {
  const move = DIALOG_MOVES.block
  if (move === undefined) return null
  return (
    <ActionDialog
      action={move.action}
      /* The button that opens a window says so; `DIALOG_MOVES` holds the commit's word. */
      label={`${move.label}…`}
      title={move.title}
      about={
        <>
          {task.ref} · {task.title}
        </>
      }
      submitLabel="Block it"
      size="sm"
      {...moveWindowOf(task)}
      disabled={disabled}
    />
  )
}
